import { createBrowserRouter, Navigate, useRoutes, RouterProvider } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
import RoleBasedGuard from '../auth/RoleBasedGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config';
//
import { LoginPage, RegisterPage, Page404, PasswordResetPage,
    PasswordResetSentPage, EmailLinkPage, UsersViewPage, JobsViewPage, HvacUnitsPage,
    BusinessesViewPage, HvacInfoPage,
    JobsInfoPage, SettingsPage, PrivacyPolicyPage,
    JobsAssignPage,RequestAccountDeletionPage, VerifyRequestAccountDeletionPage,
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  const router =  createBrowserRouter([
    {
      path: 'auth',
      children: [
        // { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage/>
            </GuestGuard>
          )
        },
        {
            path: 'reset-password',
            element: (
                <GuestGuard>
                    <PasswordResetPage/>
                </GuestGuard>
            )
        },
        {
            path: 'reset-password-sent',
            element: (
                <GuestGuard>
                    <PasswordResetSentPage/>
                </GuestGuard>
            )
        },
        {
            path: 'email-link',
            element: (
                <GuestGuard>
                    <EmailLinkPage/>
                </GuestGuard>
            )
        },
        {
            path: 'request-account-deletion',
            element: (
                <RequestAccountDeletionPage/>
            )
        },
        {
            path:'verifyDeleteCode',
            element: (
            <VerifyRequestAccountDeletionPage/>
            )
        }
      ],
    },
    // {
    //   path: 'dashboard',
    //   element: (
    //     <AuthGuard>
    //       <DashboardLayout />
    //     </AuthGuard>
    //   ),
    //   children: [
    //     { element: <DashboardPage/>, index: true },
    //     // {
    //     //     path: 'app',
    //     //     element: (
    //     //         <DashboardPage/>
    //     //     ),
    //     //     index: true
    //     // }
    //   ],
    // },
    {
        path: "users",
        element: (
            <AuthGuard>
                <DashboardLayout/>
            </AuthGuard>
        ),
        children: [
            {element: (
                <RoleBasedGuard roles={["System Admin", "Admin"]}>
                    <UsersViewPage />
                </RoleBasedGuard>
                ), index:true},
        ]
    },
    {
        path: "jobs",
        element: (
            <AuthGuard>
                <DashboardLayout/>
            </AuthGuard>
        ),
        children: [
            {
                element: <Navigate to="/jobs/all"/>, index:true
            },
            {
                path: 'all', element: <JobsViewPage/>
            },
            {
                path: 'info', element: <JobsInfoPage />
            },
            {
                path: 'assign', element: <JobsAssignPage/>
            }
        ]
    },
    {
        path: "hvacs",
        element:(
            <AuthGuard>
                <DashboardLayout/>
            </AuthGuard>
        ),
        children: [
            {
                element: <Navigate to="/hvacs/all"/>, index: true
            },
            {
                path: 'all', element: <HvacUnitsPage/>
            },
            {
                path: 'info', element: <HvacInfoPage/>
            }
        ]
    },
    {
        path: "businesses",
        element: (
            <AuthGuard>
                <DashboardLayout/>
            </AuthGuard>
        ),
        children: [
            {
                element: <BusinessesViewPage/>, index:true
            }
        ]
    },
    {
        path: "settings",
        element: (
            <AuthGuard>
                <DashboardLayout/>
            </AuthGuard>
        ),
        children: [
            {
                element: <SettingsPage/>, index: true
            }
        ]
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    {
        element: <CompactLayout/>,
        children: [
            { path: 'privacy-policy', element: <PrivacyPolicyPage/>, index: true},
        ]
    },
    {
      path: '/',
      element: <Navigate to="/auth/login" replace />
      // element: (
      //         <GuestGuard>
      //           <Login />
      //         </GuestGuard>
      //       ),
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
  return <RouterProvider router={router}/>
}
